import { render, staticRenderFns } from "./textAdd.vue?vue&type=template&id=5cb33534&scoped=true&"
import script from "./textAdd.vue?vue&type=script&lang=js&"
export * from "./textAdd.vue?vue&type=script&lang=js&"
import style0 from "./textAdd.vue?vue&type=style&index=0&id=5cb33534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb33534",
  null
  
)

export default component.exports